import { projectDrop, calculateVolume, calculateGpi } from "@/lib/tank";

// Projected stick after a metered drop, rechecked a second way, and compared to the console ullage.
export function verifyDrop({ start, delivered, diameter: d, capacity: cap, ends, ullage }) {
  const p = projectDrop(start, delivered, d, cap, ends);
  const added = calculateVolume(p.finalInches, d, cap, ends) - p.startGallons;
  const roundTripOff = Math.abs(added - delivered);
  const mid = (start + p.finalInches) / 2;
  const g = [start, mid, p.finalInches].map((h) => calculateGpi(h, d, cap, ends));
  const avgGpi = (g[0] + 4 * g[1] + g[2]) / 6;
  const gpiGain = avgGpi > 0 ? delivered / avgGpi : 0;
  const gainOff = Math.abs(gpiGain - p.stickGain);
  const methodsAgree = p.finalGallons <= cap && roundTripOff <= Math.max(15, delivered * 0.01) && gainOff <= 0.5;

  const roomLeft = ullage > 0 ? ullage - delivered : null;
  const appRoom = Math.max(0, cap - p.startGallons);
  const ullageOff = ullage > 0 ? Math.abs(appRoom - ullage) / Math.max(1, ullage) : 0;
  const ullageMatches = !(ullage > 0) || ullageOff <= 0.08 || Math.abs(p.startUllage90 - ullage) / Math.max(1, ullage) <= 0.08;

  let tone = "safe";
  if (p.finalGallons > cap || (roomLeft != null && roomLeft < 0) || p.status === "critical") tone = "critical";
  else if (p.status === "caution" || !methodsAgree || !ullageMatches || (roomLeft != null && roomLeft < cap * 0.03)) tone = "caution";
  return { ...p, roundTripOff, gpiGain, gainOff, methodsAgree, roomLeft, appRoom, ullageMatches, tone, overflow: p.finalGallons > cap };
}
